import React from 'react';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { MapPin } from 'lucide-react';

const WHATSAPP_NUMBER = '34690808995';

const FooterSection = () => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer
      data-testid="footer-section"
      className="bg-[#2C2C2A] text-[#F5F0E8] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-3 h-3 bg-[#D4A853]" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4A853]">
                Artesanal
              </span>
            </div>
            {/* Official Logo */}
            <div className="-mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/z0hmb9ix_Logo%20de%20las%20Croquetas%20de%20Mar%C3%ADa.png"
                alt="Las Croquetas de María"
                className="w-56 h-56 object-contain"
                style={{ mixBlendMode: 'lighten' }}
              />
            </div>
            <p className="text-white/50 text-sm leading-relaxed">
              Croquetas 100% caseras, hechas a mano con ingredientes de
              primera calidad. Desde Las Palmas de Gran Canaria.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold uppercase tracking-[0.2em] text-xs text-[#D4A853] mb-6">
              Navegación
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Nuestras Croquetas', id: 'catalogo' },
                { label: 'El Manifiesto', id: 'manifiesto' },
                { label: 'Área Profesionales', id: 'b2b' },
                { label: 'Preguntas Frecuentes', id: 'faq' },
              ].map(({ label, id }) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    className="text-white/50 text-sm hover:text-[#D4A853] transition-colors duration-200"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold uppercase tracking-[0.2em] text-xs text-[#D4A853] mb-6">
              Contacto
            </h4>
            <div className="space-y-4">
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 text-white/50 hover:text-[#25D366] transition-colors duration-200 text-sm"
              >
                <FaWhatsapp size={16} />
                <span>+34 690 808 995</span>
              </a>
              <div className="flex items-start gap-3 text-white/50 text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>Las Palmas de Gran Canaria</span>
              </div>
              <p className="text-white/35 text-xs leading-relaxed">
                Pedidos por WhatsApp · Pago por Bizum o efectivo
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            © 2026 Las Croquetas de María · Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Hecho con amor en Las Palmas de Gran Canaria
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
